module.exports = __webpack_public_path__ + "static/media/DSCF0029.551ce450.jpg";